class SidebarController {
  /* @ngInject */
  constructor($http, $state, $stateParams,
    $scope, Session) {
    this.$http = $http;
    this.$state = $state;
    this.$scope = $scope;
    this.$stateParams = $stateParams;
    this.Session = Session;

    this.reportListMap = {};
  }

  $onInit() {
    this.user = this.Session.read('userinfo') || {};
    this.isVendor = this.user.client.type === 'VENDOR';
    this.isCustomer = this.user.client.type === 'CUSTOMER';

    this.sidebarparams = {
      bucket: this.$stateParams.bucket || (
        this.isVendor ? 'MASTER_TRACKER' : ''
      ),
      reportId: this.$stateParams.reportId,
    };

    this.getReportList();
  }

  getReportList() {
    this.$http
      .get('/report', { params: { clientId: this.$stateParams.id } })
      .then(({ data }) => {
        this.reportTypes = data;

        const keys = Object.keys(data);
        this.reportListMap = keys.reduce((acc, curr) => {
          data[curr].forEach((x) => {
            Object.assign(acc, {
              [x.id]: x,
            });
          });

          return acc;
        }, {});

        this.$scope.$emit('reportListMap', this.reportListMap);
      });
  }

  goTo(data) {
    this.sidebarparams.bucket = data.bucket;
    this.sidebarparams.reportId = data.reportId;
    this.name = data.name;

    if (data.bucket === 'BGV_TRACKER') {
      this.$state.go('main.reports.bgvtracker');
    } else {
      this.$state.go('main.reports.list', { bucket: data.bucket, reportId: data.reportId });
    }
  }
}

export default SidebarController;



// WEBPACK FOOTER //
// ./client/app/reports/sidebar/sidebar.controller.js